import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../utils/Loader';
import Select from 'react-select';
import { fetchReportRevenue, setReportsFilters } from '../../action';
import PointsSelect from '../utils/PointsSelect';
import DateSelect from '../utils/DateSelect';
import moment from 'moment';
import SortButton from '../utils/SortButton';
import { isEmpty } from 'lodash';
import { formatNumberWithSpaces, parseNumToFixed } from '../../utils/common';
import { fetchFilials, fetchPayments, fetchSources } from '../../action/handbook';
import { defaultPlatforms, roleId } from '../../constants/app';
import { fetchUsersByRole } from '../../action/user';
import { utils, writeFileXLSX } from 'xlsx';
import ErrorContainer from '../utils/ErrorContainer';
import MultiSelect from '../utils/MultiSelect';

const styles = {
    loading: {
        minHeight: '200px',
        display: 'flex',
        justifyContent: 'center'
    }
};

const calculateExtracharge = (sum, costprice) => {
    if (!sum || !costprice || parseFloat(costprice) === 0) return 0;
    
    const priceNum = parseNumToFixed(sum);
    const costpriceNum = parseNumToFixed(costprice);
    
    const extracharge = ((priceNum - costpriceNum) / costpriceNum) * 100;
    const result = Math.round(extracharge * 100) / 100;
        
    return parseNumToFixed(result);
};

function FirstLvlRow ({item, firstLvl, color='#d5d4ff61', marginLeft = '0px' }) {
    const [ showFirstLvl, setShowFirstLvl ] = useState(false);
    
    if (item.name === 'Источник не определен') {
        if ((!item.count || item.count === 0) && (!item.receipt || item.receipt === 0) && (!item.totalSum || item.totalSum === 0)) return null;
    }
    
    const renderFirstLvl = firstLvl && firstLvl !== 'none';

    const handleClick = () => {
        if (!renderFirstLvl) return;
        setShowFirstLvl(!showFirstLvl);
    }

    return (
        <>
        <tr onClick={handleClick} className='kt-datatable__row' style={renderFirstLvl ? { cursor: 'pointer', backgroundColor: color } : { backgroundColor: color }}>
            {renderFirstLvl && <td className='kt-datatable__cell' style={{ width: '12px' }}><i className={`kt-menu__ver-arrow la la-angle-${showFirstLvl ? 'up' : 'down'}`} style={{ fontSize: '0.8rem' }}/></td>}
            <td className='kt-datatable__cell' style={{ width: 'auto'}}><span style={renderFirstLvl ? { marginLeft: '15px' } : { marginLeft: marginLeft }}>{item.name}</span></td>
            <td className='kt-datatable__cell' style={{ width: '160px'}}><span>{formatNumberWithSpaces(item.costprice) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{item.extracharge + ' %'}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(item.count) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(item.receipt) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(item.totalSum) || 0}</span></td>
        </tr>
        {renderFirstLvl && showFirstLvl && 
            Object.entries(item.detailData).map(([key, item]) => <FirstLvlRow item={item} firstLvl={null} color='#bbbaff61' marginLeft='60px' />)
        }
        </>
    )
}

function ResultRow ({items}) {
    const result = Object.values(items).reduce((acc, item) => {
        acc.totalSum += item.totalSum || 0;
        acc.count += item.count || 0;
        acc.costprice += item.costprice || 0
        return acc;
    }, { totalSum: 0, count: 0, costprice: 0 });

    const persentExtracharge = calculateExtracharge(result.totalSum, result.costprice);
    const receipt = result.count > 0 ? parseNumToFixed(result.totalSum / result.count) : 0;

    return (
        <tr className='kt-datatable__row' style={{ backgroundColor: '#cfcfcf61'}}>
            <td className='kt-datatable__cell' style={{ width: 'auto'}}><span>ИТОГО</span></td>
            <td className='kt-datatable__cell' style={{ width: '160px'}}><span>{formatNumberWithSpaces(result.costprice) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{persentExtracharge + ' %'}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(result.count) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(receipt) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(result.totalSum) || 0}</span></td>
        </tr>
    )
}

function ItemRow ({item, firstLvl, secondLvl}) {
    const [ showFirstLvl, setShowFirstLvl ] = useState(false);
    const renderFirstLvl = firstLvl && firstLvl !== 'none' && !isEmpty(item.detailData);
    const renderSecondLvl = !renderFirstLvl && secondLvl && secondLvl !== 'none' && !isEmpty(item.detailData);

    const handleClick = () => {
        if (!renderFirstLvl && !renderSecondLvl) return;
        setShowFirstLvl(!showFirstLvl);
    }

    return (
        <>
        <tr onClick={handleClick} className='kt-datatable__row' style={(renderFirstLvl || renderSecondLvl) ? { cursor: 'pointer' } : {}}>
            {(renderFirstLvl || renderSecondLvl) && <td className='kt-datatable__cell' style={{ width: '12px'}}><i className={`kt-menu__ver-arrow la la-angle-${showFirstLvl ? 'up' : 'down'}`} style={{ fontSize: '0.8rem' }}/></td>}
            <td className='kt-datatable__cell' style={{ width: 'auto'}}><span>{item.name}</span></td>
            <td className='kt-datatable__cell' style={{ width: '160px'}}><span>{formatNumberWithSpaces(item.costprice) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{item.extracharge + ' %'}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(item.count) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(item.receipt) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(item.totalSum) || 0}</span></td>
        </tr>
        {(renderFirstLvl || renderSecondLvl) && showFirstLvl && 
            Object.entries(item.detailData).map(([key, item]) => <FirstLvlRow item={item} firstLvl={renderSecondLvl ? null : secondLvl} marginLeft='45px'/>)
        }
        </>
    )
}

const renderAdress = (item) => {
    if (!item) return 'Не определен';
    return `${item.city.name ? item.city.name : '---'}, ${item.street}, ${item.house}`;
};

const firstLvlOptions = [
    { label: 'Нет', value: 'none' },
    { label: 'День', value: 'day', notRender: [ 'year' ]},
    { label: 'Неделя', value: 'week', notRender: [ 'day', 'week' ]},
    { label: 'Месяц', value: 'month', notRender: [ 'day', 'week' ]},
];

const secondLvlOptions = [
    {label: 'Нет', value: 'none'},
    {label: 'Способ доставки', value: 'delivery'},
    {label: 'Оплата', value: 'payment'},
    {label: 'Источники', value: 'source'},
];

export default function CostpriceReport() {
    const data = useSelector(state => state.reports.costprice);
    const payments = useSelector(state => state.handbook.payments);
    const points = useSelector(state => state.handbook.filials);
    const pointsCount = useSelector(state => state.handbook.count.filials);
    const pointLoading = useSelector(state => state.loaders.filials);
    const sources = useSelector(state => state.handbook.sources);
    const sourcesCount = useSelector(state => state.handbook.count.sources);
    const paymentsCount = useSelector(state => state.handbook.count.payments);

    const { result, filters, loading } = data;
    const [ regionalDirectors, setRegionalDirectors ] = useState([]);
    const [ _sort, setSort ] = useState({ field: 'name', sort: 'ASC'});
    const [ renderFilters, setRenderFilters ] = useState(filters);
    const [ platforms, setPlatforms ] = useState(defaultPlatforms);

    const dispatch = useDispatch();

    const [ renderDetail, setRenderDetail ] = useState({
        firstLvl: {label: 'Нет', value: 'none'},
        secondLvl: { label: 'Нет', value: 'none' },
    });

    useEffect(() => {
        const getData = async () => {
            const regDirs = await dispatch(fetchUsersByRole({ role: roleId.regionalDirector }));
            const resultDirs = regDirs.map((dir) => ({ value: dir.id, label: dir.name ? dir.name : dir.username, points: dir.points })).sort((a, b) => a.label.localeCompare(b.label, 'ru'));
            setRegionalDirectors(resultDirs);
            if (!pointLoading && (isEmpty(points) || points.length < pointsCount)) await dispatch(fetchFilials(null, true));
        };
        
        if ((isEmpty(payments) || payments.length < paymentsCount)) dispatch(fetchPayments(true));
        if ((isEmpty(sources) || sources.length < sourcesCount)) dispatch(fetchSources(true));
        getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!isEmpty(sources)) setPlatforms(sources);
    }, [sources]);

    const handleClickSort = (newFiled) => {
        const { field, sort } = _sort;
        if (newFiled === field) {
            const newSort = sort === 'DESC' ? 'ASC' : 'DESC';
            setSort({field: _sort.field, sort: newSort});
        } else {
            setSort({field: newFiled, sort: 'ASC'});
        }
    }

    const onChangeDateSelect = (e) => {
        if (e && e.min && e.max) {
            const updated = { ...filters};
            updated.created_at_gte = e.min;
            updated.created_at_lte = e.max;
            dispatch(setReportsFilters('costprice', updated));
        }
    }

    const setDetail = (field) => (data) => {
        const updated = { ...renderDetail, [field]: data};
        setRenderDetail(updated);
    }

    const setFilters = (field) => (data) => {
        const updated = { ...filters, [field]: data};
        dispatch(setReportsFilters('costprice', updated));
    }

    const onSearch = () => {
        dispatch(fetchReportRevenue({}, 'costprice'));
        setRenderFilters(filters);
    }

    const getFirstLvlOptions = () => {
        const date_gte = moment(filters.created_at_gte);
        const date_lte = moment(filters.created_at_lte);
        const diff = date_lte.diff(date_gte, 'days');
        let value = null;
        if (diff === 0) value = 'day';
        if (diff === 6) value = 'week';
        if (diff > 6 && diff < 180) value = 'month';
        if (diff >= 180) value = 'year';

        return value ? firstLvlOptions.filter((item) => !item.notRender || !item.notRender.includes(value)) : firstLvlOptions;
    }

    const isDisabledSearch = () => {
        if (loading) return true;
        if ((!filters.points || filters.points.length === 0) && (!filters.regionalDirectors || filters.regionalDirectors.length === 0)) return true;
        return false;        
    }
    
    const onExport = () => {
        const firstLvl = renderDetail.firstLvl.value;
        const secondLvl = renderDetail.secondLvl.value;
        const data = getGroupedData();
        const isRenderFirstLvl = firstLvl && firstLvl !== 'none' && !isEmpty(data);
        const isRenderSecondLvl = secondLvl && secondLvl !== 'none' && !isEmpty(data);

        const exportData = Object.entries(data).sort(([aKey, a], [bKey, b]) => {
            const { field, sort } = _sort;
            const aField = a[field || 'name'];
            const bField = b[field || 'name'];
            if (sort === 'DESC') {
                if (typeof aField === 'string') {
                    if(aField.toLowerCase() > bField.toLowerCase()) return -1;
                    if(aField.toLowerCase() < bField.toLowerCase()) return 1;
                    return 0;
                }
                return bField - aField;  
            } else {
                if (typeof aField === 'string') {
                    if(aField.toLowerCase() < bField.toLowerCase()) return -1;
                    if(aField.toLowerCase() > bField.toLowerCase()) return 1;
                    return 0;
                }
                return aField - bField;                                                        
            }
        }).flatMap(([firstKey, firstData]) => {
            if (!isRenderFirstLvl && !isRenderSecondLvl) {
                return {
                    'Филиал': firstKey,
                    'Себестоимость': firstData.costprice,
                    'Наценка %': firstData.extracharge,
                    'Заказы': firstData.count,
                    'Средний чек': firstData.receipt,
                    'Сумма': firstData.totalSum
                };
            }

            if (isRenderFirstLvl && !isRenderSecondLvl) {
                return Object.entries(firstData.detailData).flatMap(([secondKey, secondData]) => {
                    const dateText = firstLvl === 'day' ? 'Дата' : 'Период';   
                    return {
                        'Филиал': firstKey,
                        [dateText]: secondKey,
                        'Себестоимость': secondData.costprice,
                        'Наценка %': secondData.extracharge,
                        'Заказы': secondData.count,
                        'Средний чек': secondData.receipt,
                        'Сумма': secondData.totalSum
                    };
                });
            }

            if (isRenderFirstLvl && isRenderSecondLvl) {
                return Object.entries(firstData.detailData).flatMap(([secondKey, secondData]) => {
                    return Object.entries(secondData.detailData).flatMap(([lastKey, lastData]) => {
                        const dateText = firstLvl === 'day' ? 'Дата' : 'Период';
                        let dopText = renderDetail.secondLvl.label || '-';
                        return {
                            'Филиал': firstKey,
                            [dateText]: secondKey,
                            [dopText]: lastKey,
                            'Себестоимость': lastData.costprice,
                            'Наценка %': lastData.extracharge,
                            'Заказы': lastData.count,
                            'Средний чек': lastData.receipt,
                            'Сумма': lastData.totalSum
                        };
                    });
                });
            }

            if (!isRenderFirstLvl && isRenderSecondLvl) {
                return Object.entries(firstData.detailData).flatMap(([secondKey, secondData]) => {
                    let dopText = renderDetail.secondLvl.label || '-';
    
                    return {
                        'Филиал': firstKey,
                        [dopText]: secondKey,
                        'Себестоимость': secondData.costprice,
                        'Наценка %': secondData.extracharge,
                        'Заказы': secondData.count,
                        'Средний чек': secondData.receipt,
                        'Сумма': secondData.totalSum
                    };
                });
            }
        });

        const result = Object.values(data).reduce((acc, item) => {
            acc.totalSum += item.totalSum || 0;
            acc.count += item.count || 0;
            acc.costprice += item.costprice || 0;
            return acc;
        }, { totalSum: 0, count: 0, costprice: 0 });
        
        const receipt = result.count > 0 ? parseNumToFixed(result.totalSum / result.count) : 0;
        const persentExtracharge = calculateExtracharge(result.totalSum, result.costprice);

        exportData.push({
            'Филиал': 'ИТОГО',
            'Себестоимость': result.costprice,
            'Наценка %': persentExtracharge,
            'Заказы': result.count,
            'Средний чек': receipt,
            'Сумма': result.totalSum
        });

        const ws = utils.json_to_sheet(exportData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, 'Себестоимость');
        const dopText = [];
        const periodText = `${moment(renderFilters.created_at_gte).format('DD.MM.YYYY')} - ${moment(renderFilters.created_at_lte).format('DD.MM.YYYY')}`;
        dopText.push(periodText);
        const usersText = `${renderFilters.users.value === 'all' ? null : (renderFilters.users.value === 'authorized' ? 'Авторизированные клиенты' : 'Не авторизированные клиенты')}`
        if (usersText) dopText.push(usersText);
        if (isRenderFirstLvl) dopText.push(`Детализация 1 - ${renderDetail.firstLvl.label || '-'}`);
        if (isRenderSecondLvl) dopText.push(`Детализация 2 - ${renderDetail.secondLvl.label || '-'}`);
        const resultText = dopText.join(', ');
        writeFileXLSX(wb, `Отчет себестоимость по заказам ${resultText}.xlsx`);
    }

    const renderHead = () => {
        return(
            <div className="kt-portlet__head" style={{ flexDirection: 'column', gap: '10px' }}>
                <div className="kt-portlet__head-label">
                    <h3 className="kt-portlet__head-title">
                        Себестоимость по заказам *корректные данные с 22.04.26
                    </h3>
                </div>
                <div className='kt-separator kt-separator--border-dashed kt-separator--space-sm'/>
                <div><h6 style={{ color: 'black'}}> Поиск </h6></div>
                <div className="kt-portlet__head-toolbar" style={{ flexWrap: 'wrap', gap: '10px' }}>
                    <div style={{ width: 200 }}>
                        <label>Период *</label>
                        <DateSelect 
                        isDisabled={loading}
                        isLoading={loading}
                        optionsDate={{
                            tommorow: true,
                            period: true,
                            prevWeek: true,
                            prevMonth: true,
                        }}
                        limit={{ 
                            field: 'months',
                            value: 6
                        }}
                        width={200}
                        onChange={onChangeDateSelect}
                        />
                    </div>
                    <div>
                        <label>Филиалы {(filters.regionalDirectors && filters.regionalDirectors.length > 0) ? '' : '*'}</label>
                        <PointsSelect width={200} placeholder='Филиалы' values={filters.points} setData={setFilters('points')} disabled={loading || (filters.regionalDirectors && filters.regionalDirectors.length > 0)}/>
                    </div>
                    <div style={{ width: 200 }}>
                        <label>Региональный директор {(filters.points && filters.points.length > 0) ? '' : '*'}</label>
                        <MultiSelect data={regionalDirectors} width={200} placeholder='Рег. директор' values={filters.regionalDirectors} setData={setFilters('regionalDirectors')} loading={loading} disabled={loading || (filters.points && filters.points.length > 0)}/>
                    </div>
                    <div style={{ width: 200 }}>
                        <label>Клиенты</label>
                        <Select
                            closeMenuOnSelect={true}
                            options={[
                                {label: 'Все клиенты', value: 'all'},
                                {label: 'Только авторизированные', value: 'authorized'},
                                {label: 'Только не авторизированные', value: 'not authorized'}
                            ]}
                            onChange={setFilters('users')}
                            placeholder="Клиенты"
                            noOptionsMessage={() => 'Нет'}
                            value={filters.users}                   
                        />
                    </div>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <button disabled={isDisabledSearch()} onClick={onSearch} style={{ marginTop: '1.9rem' }} className="btn btn-primary">Найти</button>
                        {renderData() && <button disabled={loading} onClick={onExport} style={{ marginTop: '1.9rem' }} className='btn btn-dark btn-icon-sm'>Экспорт</button>}
                    </div>
                </div>
                <div className='kt-separator kt-separator--border-dashed kt-separator--space-sm'/>
                <div><h6 style={{ color: 'black'}}> Детализация </h6></div>
                <div className="kt-portlet__head-toolbar" style={{ flexWrap: 'wrap', gap: '10px' }}>
                    <div style={{ width: 200 }}>
                        <label>Уровень 1</label>
                        <Select
                            closeMenuOnSelect={true}
                            options={getFirstLvlOptions()}
                            onChange={setDetail('firstLvl')}
                            placeholder="Уровень 1"
                            noOptionsMessage={() => 'Нет'}
                            value={renderDetail.firstLvl}                   
                        />
                    </div>

                    <div style={{ width: 200 }}>
                        <label>Уровень 2</label>
                        <Select
                            closeMenuOnSelect={true}
                            options={secondLvlOptions}
                            onChange={setDetail('secondLvl')}
                            placeholder="Уровень 2"
                            noOptionsMessage={() => 'Нет'}
                            value={renderDetail.secondLvl}                   
                        />
                    </div>
                </div>
            </div>
        );
    }


    const getGroupedData = () => {
        const firstLvl = renderDetail.firstLvl.value;
        const secondLvl = renderDetail.secondLvl.value;
    
        const getFirstKeys = () => {
            const keys = new Set();
            
            if (renderFilters.points && renderFilters.points.length > 0) {
                renderFilters.points.forEach(point => {
                    const dataPoint = points.find((p) => parseInt(p.id) === parseInt(point.value));
                    if (dataPoint && dataPoint) return keys.add(renderAdress(dataPoint));
                });
            } else if (renderFilters.regionalDirectors && renderFilters.regionalDirectors.length > 0) {
                renderFilters.regionalDirectors.forEach((dir) => {
                    if (dir && dir.points && dir.points.length > 0) dir.points.forEach((point) => {
                        if (point) {
                            let pointId = point.id ? point.id : point;
                            const dataPoint = points.find((point) => point.id === pointId);
                            return keys.add(renderAdress(dataPoint));
                        }
                        keys.add('Филиал не задан');
                    });
                })
            } else {
                result.forEach((order) => {
                    if (order && order.point) return keys.add(renderAdress(order.point));
                    keys.add('Филиал не задан');
                });
            }
            
            return Array.from(keys);
        };
    
        const getDateKeys = () => {
            if (firstLvl === 'none') return [];
            
            const startDate = moment(renderFilters.created_at_gte);
            const endDate = moment(renderFilters.created_at_lte);
            const dateKeys = [];

            switch (firstLvl) {
                case 'day': {
                    let current = startDate.clone();
                    while (current <= endDate) {
                        dateKeys.push(current.format('DD.MM.YYYY'));
                        current.add(1, 'day');
                    }
                    break;
                }
                case 'week': {
                    let current = startDate.clone().startOf('isoWeek');
                    let end = endDate.clone().endOf('isoWeek');
                    
                    while (current <= end) {
                        let weekStart = current;
                        let weekEnd = current.clone().endOf('isoWeek');
        
                        if (weekStart < startDate) {
                            weekStart = startDate.format('DD.MM.YYYY');
                        } else {
                            weekStart = weekStart.format('DD.MM.YYYY');
                        }
                        
                        if (weekEnd > endDate) {
                            weekEnd = endDate.format('DD.MM.YYYY');
                        } else {
                            weekEnd = weekEnd.format('DD.MM.YYYY');
                        }
                        
                        dateKeys.push(`${weekStart} - ${weekEnd}`);
                        current.add(1, 'week');
                    }
                    break;
                }
                case 'month': {
                    let current = startDate.clone().startOf('month');
                    let end = endDate.clone().endOf('month');
                    
                    while (current <= end) {
                        const monthStart = current.format('DD.MM.YYYY');
                        const monthEnd = current.clone().endOf('month').format('DD.MM.YYYY');
                        dateKeys.push(`${monthStart} - ${monthEnd}`);
                        current.add(1, 'month');
                    }
                    break;
                }
                default: break;
            }
            
            return dateKeys;
        };
    
        const getSecondLvlKeys = () => {
            if (secondLvl === 'none') return [];
            
            switch(secondLvl) {
                case 'delivery': {
                    return ['Доставка', 'Вынос'];
                }
                case 'payment': {
                    const paymentsData = [{ Name: 'cash', VisibleName: 'Наличные'}, { Name: 'terminal', VisibleName: 'Терминал'}, { Name: 'online', VisibleName: 'Юкасса'}, ...(payments || [])];
                    return paymentsData.map((pay) => pay.VisibleName);
                }
                case 'source': {
                    const arrSources = [
                        'Сайт', 
                        'Приложение', 
                        'КЦ', 
                        'Филиал', 
                        'CRM. Принадлежность роли не определена',
                    ]
                    platforms.forEach((source) => source.name && arrSources.push(source.name));
                    arrSources.push('Источник не определен')
                    return arrSources;
                }
                default: {
                    return [];
                }
            }
        };
    
        const createData = () => {
            const firstKeys = getFirstKeys();
            const dateKeys = getDateKeys();
            const secondLvlKeys = getSecondLvlKeys();
            
            const data = {};
            
            firstKeys.forEach(firstKey => {
                const firstData = {
                    name: firstKey,
                    totalSum: 0,
                    costprice: 0,
                    extracharge: 0,
                    count: 0,
                    receipt: 0,
                    detailData: {},
                    items: [],
                };
                
                if (firstLvl !== 'none') {
                    dateKeys.forEach(dateKey => {
                        const dateData = {
                            name: dateKey,
                            totalSum: 0,
                            costprice: 0,
                            extracharge: 0,
                            count: 0,
                            receipt: 0,
                            items: [],
                        };
                        
                        if (secondLvl !== 'none') {
                            dateData.detailData = {};
                            secondLvlKeys.forEach((dopKey) => {
                                dateData.detailData[dopKey] = {
                                    name: dopKey,
                                    totalSum: 0,
                                    count: 0,
                                    receipt: 0,
                                    items: []
                                };
                            });
                        }
                        
                        firstData.detailData[dateKey] = dateData;
                    });
                } else if (secondLvl !== 'none') {
                    secondLvlKeys.forEach(dopKey => {
                        firstData.detailData[dopKey] = {
                            name: dopKey,
                            totalSum: 0,
                            count: 0,
                            receipt: 0,
                            items: [],
                        };
                    });
                }
                
                data[firstKey] = firstData;
            });
            
            return data;
        };
        
        const getDateKeyOrders = (order) => {
            const time = parseInt(order.timeZone, 10) || 3;
            const baseOrderDate = order.visible_datetime || order.created_at;
            const orderDate = moment.utc(baseOrderDate).add(time, 'hours');
            switch(firstLvl) {
                case 'day': {
                    return orderDate.format('DD.MM.YYYY');
                }
                case 'week': {
                    const startDate = moment(renderFilters.created_at_gte);
                    const endDate = moment(renderFilters.created_at_lte);
                    let weekStart = orderDate.clone().startOf('isoWeek');
                    let weekEnd = orderDate.clone().endOf('isoWeek');
    
                    if (weekStart < startDate) {
                        weekStart = startDate.format('DD.MM.YYYY');
                    } else {
                        weekStart = weekStart.format('DD.MM.YYYY');
                    }
                
                    if (weekEnd > endDate) {
                        weekEnd = endDate.format('DD.MM.YYYY');
                    } else {
                        weekEnd = weekEnd.format('DD.MM.YYYY');
                    }
                    
                    return `${weekStart} - ${weekEnd}`;
                }
                case 'month': {
                    const monthStart = orderDate.startOf('month').format('DD.MM.YYYY');
                    const monthEnd = orderDate.endOf('month').format('DD.MM.YYYY');
                    return `${monthStart} - ${monthEnd}`;
                }
                default: {
                    return null;
                }
            }
        };
    
        const getSecondLvlKeyOrders = (order) => {
            switch(secondLvl) {
                case 'delivery': {
                    return order.deliveryMethod === 'delivery' ? 'Доставка' : 'Вынос';
                }
                case 'payment': {
                    const paymentsData = [...(payments || []), { Name: 'cash', VisibleName: 'Наличные'}, { Name: 'terminal', VisibleName: 'Терминал'}, { Name: 'online', VisibleName: 'Юкасса'}];
                    const pay = paymentsData.find(p => p.Name === order.payment);
                    return (pay && pay.VisibleName) ? pay.VisibleName : 'Не определена';
                }
                case 'source': {
                    if (order.aggData && order.aggData.platform) {
                        const platform = platforms.find((source) => source.value === order.aggData.platform);
                        if (platform && platform.name) return platform.name;
                        return order.aggData.platform;
                    }

                    if (order.source && order.source !== 'crm') {
                        const platform = platforms.find((source) => source.value === order.source);
                        if (platform && platform.name) return platform.name;
                    }
    
                    if (order.source !== 'crm') {
                        if (order.isSite) return 'Сайт';
                        return 'Приложение';
                    }
                    
                    if (order.source === 'crm') {
                        if (order.authorRole) {
                            if ([roleId.operator, roleId.coordinator, roleId.admin, roleId.directorCC].includes(order.authorRole)) return 'КЦ';
                            if ([roleId.manager, roleId.cashier, roleId.regionalDirector].includes(order.authorRole)) return 'Филиал';
                            if (![roleId.operator, roleId.coordinator, roleId.admin, roleId.directorCC, roleId.manager, roleId.cashier, roleId.operationDirector].includes(order.authorRole)) return 'CRM. Принадлежность роли не определена';
                        }
                    }
                    
                    return 'Источник не определен';
                }
                default: {
                    return null;
                }
            }
        };
    
        const fillNullData = (data) => {
            const updated = JSON.parse(JSON.stringify(data));
            
            (result || []).forEach((order) => {
                const totalPrice = parseFloat(order.totalPrice) || 0;
                const costpriceOrder = parseFloat(order.costprice) || 0;
                const firstKey = order.point ? renderAdress(order.point) : 'Филиал не задан';
                
                if (updated[firstKey]) {
                    updated[firstKey].totalSum = parseNumToFixed((parseFloat(updated[firstKey].totalSum) || 0) + totalPrice);
                    updated[firstKey].count += 1;
                    updated[firstKey].costprice = parseNumToFixed((parseFloat(updated[firstKey].costprice) || 0) + costpriceOrder);
                    
                    if (firstLvl !== 'none') {
                        const dateKey = getDateKeyOrders(order);
                        if (dateKey && updated[firstKey].detailData[dateKey]) {
                            const dateData = updated[firstKey].detailData[dateKey];
                            dateData.totalSum = parseNumToFixed((parseFloat(dateData.totalSum) || 0) + totalPrice);
                            dateData.count += 1;
                            dateData.costprice = parseNumToFixed((parseFloat(dateData.costprice) || 0) + costpriceOrder);
                            dateData.items.push(order);
                            
                            if (secondLvl !== 'none') {
                                const dopKey = getSecondLvlKeyOrders(order);
                                if (dopKey && dateData.detailData && dateData.detailData[dopKey]) {
                                    const dopData = dateData.detailData[dopKey];
                                    dopData.totalSum = parseNumToFixed((parseFloat(dopData.totalSum) || 0) + totalPrice);
                                    dopData.count += 1;
                                    dopData.costprice = parseNumToFixed((parseFloat(dopData.costprice) || 0) + costpriceOrder);
                                    dopData.items.push(order);
                                }
                            }
                        }
                    } else if (secondLvl !== 'none') {
                        const dopKey = getSecondLvlKeyOrders(order);
                        if (dopKey && updated[firstKey].detailData[dopKey]) {
                            const dopData = updated[firstKey].detailData[dopKey];
                            dopData.totalSum = parseNumToFixed((parseFloat(dopData.totalSum) || 0) + totalPrice);
                            dopData.count += 1;
                            dopData.costprice = parseNumToFixed((parseFloat(dopData.costprice) || 0) + costpriceOrder);
                            dopData.items.push(order);
                        }
                    }
                }
            });
                        
            Object.keys(updated).forEach((firstKey) => {
                const firstData = updated[firstKey];
                if (firstData.count > 0) firstData.receipt = parseNumToFixed(firstData.totalSum / firstData.count);
                firstData.extracharge = calculateExtracharge(firstData.totalSum, firstData.costprice);
                if (firstLvl !== 'none') {
                    Object.keys(firstData.detailData).forEach((dateKey) => {
                        const dateData = firstData.detailData[dateKey];
                        if (dateData.count > 0) dateData.receipt = parseNumToFixed(dateData.totalSum / dateData.count);
                        dateData.extracharge = calculateExtracharge(dateData.totalSum, dateData.costprice);
                        
                        if (secondLvl !== 'none' && dateData.detailData) {
                            Object.keys(dateData.detailData).forEach((dopKey) => {
                                const dopData = dateData.detailData[dopKey];
                                if (dopData.count > 0) dopData.receipt = parseNumToFixed(dopData.totalSum / dopData.count);
                                dopData.extracharge = calculateExtracharge(dopData.totalSum, dopData.costprice);
                            });
                        }
                    });
                } else if (secondLvl !== 'none') {
                    Object.keys(firstData.detailData).forEach((dopKey) => {
                        const dopData = firstData.detailData[dopKey];
                        if (dopData.count > 0) dopData.receipt = parseNumToFixed(dopData.totalSum / dopData.count);
                        dopData.extracharge = calculateExtracharge(dopData.totalSum, dopData.costprice);
                    });
                }
            });
            
            return updated;
        };
    
        const data = createData();
        const filledData = fillNullData(data);
        
        return filledData;
    };

    const renderTable = () => {
        const { field, sort } = _sort;
        const firstLvl = renderDetail.firstLvl.value;
        const secondLvl = renderDetail.secondLvl.value;
        const data = getGroupedData();

        return(
            <div className='kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded'>
                <table className='kt-datatable__table' style={{ width: '100%'}}>
                    <thead className='kt-datatable__head' style={{ position: 'sticky' }}>
                        <tr className='kt-datatable__row'>
                            <th className='kt-datatable__cell' style={{ width: 'auto' }}>
                                <SortButton 
                                className={field === 'name' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='Наименование' onClick={() => handleClickSort('name')} 
                                up={field === 'name' && sort === 'ASC'}
                                />
                            </th>
                            <th className='kt-datatable__cell' style={{ width: '160px' }}>
                                <SortButton 
                                className={field === 'costprice' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='Себестоимость' 
                                onClick={() => handleClickSort('costprice')} 
                                up={field === 'costprice' && sort === 'ASC'}
                                />
                            </th>
                            <th className='kt-datatable__cell' style={{ width: '140px' }}>
                                <SortButton 
                                className={field === 'extracharge' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='Наценка %' 
                                onClick={() => handleClickSort('extracharge')} 
                                up={field === 'extracharge' && sort === 'ASC'}
                                />
                            </th>
                            <th className='kt-datatable__cell' style={{ width: '140px' }}>
                                <SortButton 
                                className={field === 'count' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='Заказы' 
                                onClick={() => handleClickSort('count')} 
                                up={field === 'count' && sort === 'ASC'}
                                />
                            </th>
                            <th className='kt-datatable__cell' style={{ width: '140px' }}>
                                <SortButton 
                                className={field === 'receipt' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='Ср. чек' 
                                onClick={() => handleClickSort('receipt')} 
                                up={field === 'receipt' && sort === 'ASC'}
                                />
                            </th>
                            <th className='kt-datatable__cell' style={{ width: '140px' }}>
                            <SortButton 
                                className={field === 'totalSum' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='Сумма' 
                                onClick={() => handleClickSort('totalSum')} 
                                up={field === 'totalSum' && sort === 'ASC'}
                                />
                            </th>
                        </tr>
                    </thead>
                    <tbody className='kt-datatable__body'>
                        {Object.entries(data)
                        .sort(([aKey, a], [bKey, b]) => {
                            const { field, sort } = _sort;
                            const aField = a[field || 'name'];
                            const bField = b[field || 'name'];
                            if (sort === 'DESC') {
                                if (typeof aField === 'string') {
                                    if(aField.toLowerCase() > bField.toLowerCase()) return -1;
                                    if(aField.toLowerCase() < bField.toLowerCase()) return 1;
                                    return 0;
                                }
                                return bField - aField;  
                            } else {
                                if (typeof aField === 'string') {
                                    if(aField.toLowerCase() < bField.toLowerCase()) return -1;
                                    if(aField.toLowerCase() > bField.toLowerCase()) return 1;
                                    return 0;
                                }
                                return aField - bField;                                                        
                            }
                        })
                        .map(([key, item]) => <ItemRow item={item} firstLvl={firstLvl} secondLvl={secondLvl}/>)}
                        <ResultRow items={data} />
                    </tbody>
                </table>
            </div>
        );
    }

    const renderData = () => {
        if ((!result || result.length === 0) && (!renderFilters.points || renderFilters.points.length === 0) && (!renderFilters.regionalDirectors || renderFilters.regionalDirectors.length === 0)) return false;
        return true;       
    }

    const renderBody = () => {
        if (loading || pointLoading) return <div style={styles.loading}><Loader /></div>;        

        if (!renderData()) return <div className='kt-portlet'> 
            <div className='kt-portlet__body'>Нет данных</div> 
        </div>

        return(
        <div className="kt-portlet">
            <ErrorContainer field="costprice" style={{ margin: '20px 20px 0px 20px' }} hasCloseButton={true}/>
            <div className='kt-portlet__body'>
            {renderTable()}    
            </div> 
        </div>
        );
    }

    return (
        <>
            <div className="kt-portlet">
                {renderHead()}
            </div>
            {renderBody()}
        </>         
    );
}